import { createRef, useEffect, useRef, useMemo } from 'react';
import ChartJs from 'chart.js/auto';
import DataLabelsPlugin from 'chartjs-plugin-datalabels';

ChartJs.register(DataLabelsPlugin);

function init(el, props) {
  const canvas = el?.getContext('2d');
  if (!canvas) return;
  const chart = new ChartJs(canvas, {
    type: props.type,
    data: props.data,
    options: props.options,
    plugins: props.plugins,
  });
  el.instance = chart;
}

export default function Chart({
  type = 'line',
  data = { datasets: [] },
  options = {},
  plugins,
  width = 'auto',
  height = 'auto',
  className = '',
  ...computedProps
}) {
  const props = useMemo(
    () => ({ type, data, options, plugins, width, height, className }),
    [type, data, options, plugins, width, height, className]
  );
  const initialRender = useRef(true);
  const chartRef = createRef();

  useEffect(() => {
    if (initialRender.current) {
      if (chartRef.current) init(chartRef.current, props);
      initialRender.current = false;
    } else if (chartRef.current?.instance) {
      chartRef.current.instance.data = props.data;
      if (props.options) chartRef.current.instance.options = props.options;
      chartRef.current.instance.update();
    }
  }, [props, chartRef]);

  return (
    <div
      style={{
        width: width === 'auto' ? '100%' : `${width}px`,
        height: height === 'auto' ? '100%' : `${height}px`,
      }}
    >
      <canvas {...computedProps} ref={chartRef} className={className} />
    </div>
  );
}
